import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { get_root_value } from "src/utils/domUtils";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
  Pagination,
} from "@mui/material";
// components
// import Page from "../components/Page";
// import Label from "./Label";
// import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import Label from "src/components/Label";
import { UserListHead, UserListToolbar } from "src/components/_dashboard/user";
// import UserListHead from "./UserListHead";
// import GoalStatementMenu from "../components/_dashboard/user/GoalStatementMenu";
// import { QuestionListing } from "src/DAL/GoalStatement/GoalStatement";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { htmlDecode } from "src/utils/convertHtml";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";

import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";

// import {
//   consultantListing,
//   DeleteConsultantApi,
// } from "src/DAL/consultant/consultant";
import { transactionListApi } from "../../DAL/TransactionList/transactionList";
import moment from "moment";
import {
  convertCurrencyToSign,
  get_date_with_user_time_zone,
} from "src/utils/constants";
import { bookingListApi } from "src/DAL/Booking/bookingApi";
import CustomDrawer from "src/components/DrawerForm/CustomDrawer";
import {
  attitudeAssessmentListApi,
  attitudeMemberAssessmentListApi,
  dailyDynamiteMemberAssessmentListApi,
} from "src/DAL/AssessmentApi/assessmentApi";
import CustomPopover from "src/components/CustomPopover";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import IntentionsList from "./IntentionsList";

//
// import USERLIST from "../_mocks_/user";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "number", label: "#", alignRight: false },
  { id: "email", label: "Name", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "coins", label: "Attitude Coins", alignRight: false },
  { id: "date", label: "Completed Date", alignRight: false },
  { id: "action", label: "Action", alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    console.log(array, "array");
    return filter(
      array,
      (_user) => _user?.email?.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
export default function MemberDailyDynamiteList() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const params = useParams();
  const { userInfo, adminTimeZone } = useContentSetting();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("number");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [open, setOpen] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [member, setData] = useState([]);
  const [totalMembers, setTotalMembers] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [UserId, setUserId] = useState(false);
  const [drawerState, setDrawerState] = useState(false);
  const [messages, setMessages] = useState(false);
  const [editDrawerState, setEditDrawerState] = useState(false);
  const [intentionsList, setIntentionsList] = useState(false);

  // const handleOpenDrawer = (data) => {
  //   setMessages(data);
  //   setDrawerState(true);
  // };
  // const handleCloseDrawer = () => {
  //   setDrawerState(false);
  // };

  const handleOpen = (e) => {
    setUserId(e);
    setOpen(true);
  };

  const handleRequestSort = (event, property) => {
    // const isAsc = orderBy === property && order === "asc";
    // setOrder(isAsc ? "desc" : "asc");
    // setOrderBy(property);
  };

  const getConsultantListing = async () => {
    setIsLoading(true);

    try {
      setIsLoading(true);
      const result = await dailyDynamiteMemberAssessmentListApi(
        params.id,
        page,
        rowsPerPage
      );

      if (result.code === 200) {
        const data = result.dynamite_diaries.map((val, index) => {
          return {
            id: val._id,
            Username: result.member.first_name + " " + result.member.last_name,
            email: result.member.email,
            object: val,
            statement_array: val.statement_array,
            coins: val.dynamiye_diary_coins_count,
            assessment_results: val.assessment_results,
            time: get_date_with_user_time_zone(
              val.date_time,
              "DD-MM-YYYY hh:mm A",
              userInfo.time_zone,
              adminTimeZone
            ),

            count: index + 1 + rowsPerPage * page,
          };
        });
        setUserList(data);
        setTotalPages(result.total_page < 0 ? result.total_pages : 0);
        setTotalMembers(result.total_count);
        setIsLoading(false);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    } catch (error) {}
  };
  const handleEdit = (value) => {
    navigate(`/members/history/${value.id}`, {
      state: value,
    });
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deleteDoc.id;
    if (result.code === 200) {
      // getConsultantListing();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const handleOpenDrawer = (value) => {
    console.log(value, "intentions");
    setIntentionsList(value.statement_array);
    setEditDrawerState(true);
  };

  const handleCloseDrawer = () => {
    setEditDrawerState(false);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleNavigate = () => {
    navigate(`/consultant/add-consultant`);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;

  const filteredUsers = applySortFilter(
    userList,
    getComparator(order, orderBy),
    filterName
  );

  useEffect(() => {
    getConsultantListing();
  }, [page, rowsPerPage]);
  const MENU_OPTIONS = [
    {
      label: "View History",
      icon: "akar-icons:edit",
      handleClick: handleOpenDrawer,
    },
    // {
    //   label: "Delete",
    //   icon: "ant-design:delete-twotone",
    //   handleClick: handleAgreeDelete,
    // },
  ];

  const isUserNotFound = filteredUsers.length === 0;
  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        open={openDelete}
        setOpen={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />

      <div className="container">
        <div className="row">
          <div className="col-12">
            <IconButton
              className="back-screen-button mb-4"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
          </div>
          <div className="col-lg-8 col-sm-12">
            <h2>Daily Dynamite</h2>
          </div>
        </div>

        <Card style={{ overflowX: "auto" }}>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={userList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers.map((row, i) => {
                  const {
                    id,
                    name,
                    Username,
                    email,
                    phone,
                    date,
                    duration,
                    time,
                    count,
                    coins,
                  } = row;
                  const isItemSelected = selected.indexOf(name) !== -1;

                  return (
                    <TableRow
                      hover
                      key={id}
                      tabIndex={-1}
                      role="checkbox"
                      selected={isItemSelected}
                      aria-checked={isItemSelected}
                    >
                      <TableCell align="left">{count}</TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        onClick={() => handleEdit(row)}
                        className="pointer"
                      >
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Typography variant="subtitle2" noWrap>
                            {htmlDecode(Username)}
                          </Typography>
                        </Stack>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {email}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {coins ? coins : 0}
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2" noWrap>
                          {time}
                        </Typography>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <CustomPopover
                          menu={MENU_OPTIONS}
                          data={row}
                          center="false"
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
                {/* {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={totalMembers}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          {/* <Pagination
            count={totalPages + 1}
            page={pageCount}
            defaultPage={0}
            onChange={handleChangePage}
            className="pagination-style"
          /> */}
        </Card>
      </div>
      <CustomDrawer
        isOpenDrawer={editDrawerState}
        onOpenDrawer={handleOpenDrawer}
        onCloseDrawer={handleCloseDrawer}
        pageTitle="Intentions"
        componentToPassDown={
          <IntentionsList
          // setIsLoading={setIsLoading}
          // eventDetailData={eventDetailData}
          // dataList={getEventListing}
          // onCloseDrawer={handleCloseDrawer}
          />
        }
      />
    </>
  );
}
